export const getRGBAColor = (rgb: string, alpha: string) =>
  rgb.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
